const commentItems = [
  {
    name: '星辰大海',
    date: '2026.07.30',
    content: '桃子影院真的绝了！之前要开会员才能看4K的剧，这里全部免费而且画质真的没话说。昨天一口气追完了《暗夜追凶》全集，流畅不卡顿，推荐给所有追剧的朋友！',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20dark%20style%20abstract%20portrait%20avatar%2C%20warm%20tones%2C%20simple%20geometric%20shapes%2C%20clean%20design%2C%20dark%20background&width=80&height=80&seq=avatar-user-01&orientation=squarish',
    rating: 5,
  },
  {
    name: '电影重度患者',
    date: '2026.07.28',
    content: '作为阅片3000+的老影迷，桃子影院的片库丰富程度让我惊喜。很多冷门文艺片和经典老片都能找到高清版本，而且更新速度很快，院线下映不久就能看了。',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20abstract%20profile%20avatar%20with%20cinematic%20warm%20lighting%2C%20simple%20geometric%20design%2C%20dark%20atmosphere%2C%20amber%20accents&width=80&height=80&seq=avatar-user-02&orientation=squarish',
    rating: 5,
  },
  {
    name: '追剧小达人',
    date: '2026.07.26',
    content: '每天都要打开桃子影院看看有没有更新，追剧日历功能太实用了！韩剧和国产剧同步更新，再也不用到处找资源了。画质清晰、播放流畅，已成为我的主力观影平台。',
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20minimalist%20avatar%20portrait%2C%20warm%20peach%20and%20gold%20gradients%2C%20simple%20shapes%2C%20dark%20background%2C%20clean%20modern%20design&width=80&height=80&seq=avatar-user-03&orientation=squarish',
    rating: 5,
  },
  {
    name: '宅家影视控',
    date: '2026.07.25',
    content: '周末在家用投影仪连着看了一整天，4K蓝光的画质投到120寸幕布上效果炸裂！关键是全程免费，真的良心平台。APP也做得很好用，离线缓存功能通勤路上追剧太方便了。',
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20minimalist%20user%20avatar%20with%20soft%20golden%20light%2C%20simple%20geometric%20design%2C%20dark%20background%2C%20warm%20amber%20tones&width=80&height=80&seq=avatar-user-04&orientation=squarish',
    rating: 5,
  },
];

export default function Comments() {
  return (
    <section id="comments" className="relative py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[900px] mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium text-secondary-400 bg-secondary-500/10 rounded-full mb-4">
            用户口碑
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50">
            观众真实评价
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-400 max-w-2xl mx-auto">
            听听桃子影院的用户怎么说
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {commentItems.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-200/60 rounded-xl p-5 border border-background-300/20"
            >
              <div className="flex items-start gap-3 mb-3">
                <div className="w-10 h-10 flex-shrink-0 rounded-full overflow-hidden bg-background-300">
                  <img
                    src={item.avatar}
                    alt={item.name}
                    className="w-full h-full object-cover"
                    onError={(e) => {
                      const target = e.currentTarget;
                      target.style.display = 'none';
                      const parent = target.parentElement;
                      if (parent) {
                        parent.innerHTML = `<div class="w-full h-full flex items-center justify-center text-foreground-400 text-sm font-bold">${item.name.charAt(0)}</div>`;
                      }
                    }}
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between gap-2">
                    <h3 className="font-heading text-sm font-semibold text-foreground-100">{item.name}</h3>
                    <span className="text-xs text-foreground-500 whitespace-nowrap">{item.date}</span>
                  </div>
                  <div className="flex items-center gap-0.5 mt-1">
                    {Array.from({ length: item.rating }).map((_, i) => (
                      <i key={i} className="ri-star-fill text-primary-400 text-xs"></i>
                    ))}
                  </div>
                </div>
              </div>
              <p className="text-sm text-foreground-400 leading-relaxed">
                {item.content}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}